import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { logout } from '../utils/utils';

interface RequireCompanyCodeProps {
    children: React.ReactNode;
}

const RequireCompanyCode = ({ children }: RequireCompanyCodeProps) => {
    const { companyCode: urlCompanyCode } = useParams<{ companyCode: string }>();
    const navigate = useNavigate();

    const storedCompanyCode = localStorage.getItem(`current_company_code`) || '';
  
    useEffect(() => {
        if (!storedCompanyCode || (urlCompanyCode && urlCompanyCode !== storedCompanyCode)) {
            logout(navigate, { replace: true });
        }
    }, [storedCompanyCode, urlCompanyCode, navigate]);

    if (!storedCompanyCode || (urlCompanyCode && urlCompanyCode !== storedCompanyCode)) {
        return null;
    }

    return <>{children}</>;
};

export default RequireCompanyCode;